<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-shield-account</v-icon> <span>{{$t('export.add_crumb')}}</span>
        </h1>
  
        <div class="mt-16">
          <export ></export>
        </div>
    </section>
  </template>
  <script>
  import Export from '@/components/exports/Export'
  
  export default {
    components: {
        Export
    },
    beforeCreate(){
      document.title = this.$t('app_name')
    },
    data: () => ({
      
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "exports.read"])) {
        this.$router.push('/admin');
      }
  
    },
    methods:{
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.exports'),
            disabled: false,
            to: '/admin/exports',
            exact: true,
          },
          {
            text: this.$t('export.add_crumb'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  